import { Dispatch, GetState } from "common/types/redux";

import { getClient } from "services";
import { FeedbackType } from "services/userFeedbackService/types";

import { makeCrudStateActionFactories } from "seneca-common/utils/apiStates";

import "../analytics";
import { feedbackCrudConfig } from "../consts";
import { FeedbackDetails } from "../types";

const getUserServiceClient = () => getClient("userFeedbackService");

const { createActionFactory } =
  makeCrudStateActionFactories(feedbackCrudConfig);

const saveModuleFeedbackAction = createActionFactory({
  requestFunction: feedbackObject =>
    getUserServiceClient().giveFeedback(FeedbackType.Module, feedbackObject)
});

const saveGeneralFeedbackAction = createActionFactory({
  requestFunction: feedbackObject =>
    getUserServiceClient().giveFeedback(FeedbackType.General, feedbackObject)
});

export const saveModuleFeedback =
  ({
    accountType,
    feedbackType,
    feedback,
    browser,
    appVersion,
    meta
  }: FeedbackDetails) =>
  (dispatch: Dispatch, getState: GetState) => {
    if (!meta || !meta.moduleId) {
      return null;
    }

    const {
      courseId,
      sectionId,
      contentId,
      moduleId,
      content,
      moduleType,
      userAnswer
    } = meta;

    return dispatch(
      saveModuleFeedbackAction(
        {
          courseId,
          sectionId,
          contentId,
          moduleId,
          moduleType,
          content,
          userAnswer,
          browser,
          appVersion,
          feedbackType,
          feedback,
          accountType
        },
        moduleId
      )
    );
  };

export const saveDashboardFeedback =
  ({ accountType, feedback, browser, appVersion }: FeedbackDetails) =>
  (dispatch: Dispatch, getState: GetState) => {
    return dispatch(
      saveGeneralFeedbackAction(
        {
          browser,
          appVersion,
          feedback,
          accountType
        },
        "dashboard"
      )
    );
  };
